import { Box } from '@grupoboticario/flora-react'

import * as P from './pages.styles'

const OauthPage = () => {
  return <Box css={P.pageWrapperCss} />
}

export { OauthPage }
